import React from "react";
import MinimalPublicPage from "./MinimalPublicPage";

export default function AntiCheatPage() {
  return (
    <MinimalPublicPage
      eyebrow="Anti-cheat"
      title="Server-side signals. Human review."
      description="Ouro watches gameplay patterns from the server, then routes suspicious behavior into review instead of relying on vibes."
      points={[
        {
          title: "Tick-by-tick context",
          body: "Match events, aim behavior, movement, utility, and timing are collected during live games.",
        },
        {
          title: "Patterns over clips",
          body: "The system looks for repeated suspicious behavior across moments, not one lucky shot.",
        },
        {
          title: "Actionable review",
          body: "Signals feed moderation and reputation decisions so the queue can get cleaner over time.",
        },
      ]}
      secondaryLabel="Trust & safety"
      secondaryTo="/trust-and-safety"
    />
  );
}
